<template>
    <v-layout justify-center class="pa-4">
        <v-responsive width="100%" height="100%">
            <list-heading title="나누리상품권 주문 관리" v-model="showsSearch" showsFilterButton />

            <list-search-default
                v-bind="{
                    showsSearch,
                    loading,
                    searchKeys,
                }"
                v-on="{ search }"
            />

            <v-row class="ma-n2 mt-n1">
                <v-col class="pa-2" cols="auto" md="auto">
                    <list-summary v-bind="{ summary }" />
                </v-col>
                <v-col class="pa-2" cols="12" md="auto">
                    <nshop-order-list-state />
                </v-col>
                <v-col class="pa-2" cols="12" md="auto">
                    <nshop-order-list-method />
                    <nshop-order-list-pg />
                </v-col>
                <v-col class="pa-2" cols="auto" md="auto">
                    <nshop-order-list-member />
                </v-col>
                <v-col v-if="showsViewer" class="pa-2" cols="auto" md="auto">
                    <nshop-list-viewer />
                </v-col>
                <v-spacer />
                <v-col class="pa-2" cols="auto" md="auto">
                    <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                        <v-card outlined style="overflow: hidden;">
                            <v-btn height="40" color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                <v-icon> mdi-microsoft-excel </v-icon>
                                <span> 엑셀다운로드 </span>
                            </v-btn>
                        </v-card>
                    </list-excel>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" ref="data-table">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter') && header.value !== 'pins')" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

                        <!-- 핀이 많으면 행이 길어지므로 화면에는 첫 핀과 장수만 보이고, 누르면 전체 핀 목록 창을 연다. 엑셀은 headers 의 formatter 로 전체 핀을 내보낸다. -->
                        <template #[`item.pins`]="{ value, item }">
                            <nshop-order-pins-dialog v-if="value && value.length" :order="item">
                                <template #activator="{ attrs, on }">
                                    <div class="cursor-pointer" v-bind="attrs" v-on="on">
                                        <div class="primary--text">{{ value[0].pno }}</div>
                                        <div v-if="value.length > 1" class="grey--text">외 {{ value.length - 1 }}장</div>
                                    </div>
                                </template>
                            </nshop-order-pins-dialog>
                            <template v-else>-</template>
                        </template>

                        <template #[`item.member.isBlock`]="{ item }">
                            <v-switch v-model="item.member.isBlock" v-bind="{ ...attrs_switch, loading }" @change="(isBlock) => updateMember({ _id: item._member, isBlock })" dense />
                        </template>
                        <template #[`item.orderNo`]="{ item }">
                            <nshop-order-view :_order="item._id" @search="search">
                                <template #activator="{ attrs, on }">
                                    <v-btn x-small text tile class="pa-0 caption" v-bind="attrs" v-on="on">{{ item.orderNo || "-" }}</v-btn>
                                </template>
                            </nshop-order-view>
                        </template>
                        <template #[`item.resend`]="{ item }">
                            <v-btn v-bind="{ loading }" large text icon tile block @click="resend(item)">
                                <v-icon small>mdi-receipt-text-send-outline</v-icon>
                            </v-btn>
                        </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch } from "@/assets/variables";
import { initDataTableHeaders } from "@/assets/lib";
import { NSHOP_ORDER_PAYMENT_METHODS, NSHOP_ORDER_STATES, OPENBANK_PG_TEXTS } from "@/store/nshop";

import ListExcel from "@/components/console/dumb/list/list-excel.vue";
import ListHeading from "@/components/console/dumb/list/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list/list-search-default.vue";
import ListSummary from "@/components/console/dumb/list/list-summary.vue";
import NshopListViewer from "@/components/console/nshop/nshop-list-viewer.vue";
import NshopOrderListMember from "@/components/console/nshop/orders/nshop-order-list-member.vue";
import NshopOrderListMethod from "@/components/console/nshop/orders/nshop-order-list-method.vue";
import NshopOrderListPg from "@/components/console/nshop/orders/nshop-order-list-pg.vue";
import NshopOrderListState from "@/components/console/nshop/orders/nshop-order-list-state.vue";
import NshopOrderView from "@/components/console/nshop/orders/nshop-order-view.vue";
import NshopOrderPinsDialog from "@/components/console/nshop/orders/nshop-order-pins-dialog.vue";

const searchKeys = [
    { text: "주문번호", value: "orderNo" },
    { text: "권종", value: "orderName" },
];

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearchDefault,
        ListSummary,
        NshopListViewer,
        NshopOrderListMember,
        NshopOrderListMethod,
        NshopOrderListPg,
        NshopOrderListState,
        NshopOrderView,
        NshopOrderPinsDialog,
    },
    data: () => ({
        orders: [],

        limit: 20,
        summary: { totalCount: 0 },

        searchKeys,
        attrs_switch,

        loading: false,
        showsSearch: true,
    }),
    computed: {
        // 뷰어 콘솔은 애초에 자기 주문만 조회되므로(서버에서 강제) 추천인 필터·컬럼이 의미가 없다.
        showsViewer() {
            return !this.$hasScope(["viewer"]);
        },
        headers() {
            return initDataTableHeaders([
                {
                    text: "no",
                    value: "index",
                    width: +70,
                    align: "end",
                    formatterType: "number",
                },
                {
                    text: "생성일시",
                    value: "createdAt",
                    width: 100,
                    formatterType: "datetime",
                },
                {
                    text: "결제일시",
                    value: "paymentAt",
                    width: 100,
                    formatterType: "datetime",
                },
                {
                    text: "주문번호",
                    value: "orderNo",
                },
                {
                    text: "권종",
                    value: "orderName",
                },
                {
                    text: "pin 번호",
                    value: "pins",
                    formatter: (value = []) => value.map((pin) => pin?.pno).join("\n") || "-",
                },
                {
                    text: "상태",
                    value: "state",
                    formatter: (value) => NSHOP_ORDER_STATES[value]?.text || "-",
                    width: +80,
                },
                {
                    text: "결제금액",
                    value: "price.sum",
                    align: "end",
                    formatterType: "number",
                    formatterSuffix: "원",
                    width: 100,
                },
                {
                    text: "실결제금액",
                    value: "price.sale",
                    align: "end",
                    formatterType: "number",
                    formatterSuffix: "원",
                    width: 100,
                },
                {
                    text: "결제수단",
                    value: "payment.method",
                    formatter: (value) => NSHOP_ORDER_PAYMENT_METHODS[value]?.text || "-",
                    width: 120,
                },
                {
                    // 내 통장 결제는 쿠콘·KG이니시스 결제창을 번갈아 쓰므로 어느 결제사로 결제됐는지 따로 보여준다.
                    // 엑셀 다운로드도 이 formatter 를 그대로 쓰므로 HTML 없이 글자만 만든다. 배정 이전 주문은 쿠콘.
                    text: "결제사",
                    value: "payment.openbank.pg",
                    formatter: (value, item) => (item?.payment?.method === "openbank" ? OPENBANK_PG_TEXTS[value || "checkpay"] || value || "-" : "-"),
                    width: 110,
                },
                {
                    text: "문자수신\n전화번호",
                    value: "member.phone",
                    width: 120,
                },
                {
                    text: "ID",
                    value: "member.username",
                    width: 120,
                },
                {
                    text: "구매자",
                    value: "member.name",
                    width: +80,
                },
                {
                    text: "추천인\n(뷰어)",
                    value: "viewer.refid",
                    width: 120,
                    shows: this.showsViewer,
                    formatter: (value, item) => value || item?.viewer?.username || "-",
                },
                {
                    text: "사용자\n차단",
                    value: "member.isBlock",
                    align: "center",
                    width: 60,
                    class: "pa-0",
                    cellClass: "pa-0",
                },
                {
                    text: "문자\n재발송",
                    value: "resend",
                    align: "center",
                    width: 60,
                    class: "pa-0",
                    cellClass: "pa-0",
                },
            ]);
        },
        items() {
            return this.orders.map((item, index) => ({
                ...item,
                index: this.summary.totalCount - index - this.skip,
            }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        async init() {
            this.orders = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                let { summary, orders } = await api.console.nshop.orders.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.orders = orders;
            } finally {
                this.loading = false;
            }
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { orders } = await api.console.nshop.orders.gets({
                    headers: { skip, limit },
                    params,
                });

                let { headers } = this;
                let fileName = "나누리상품권_주문관리";
                this.$excel(orders, headers, fileName);
            } finally {
                this.loading = false;
            }
        },

        async updateMember(member) {
            if (this.loading) return;
            else this.loading = true;

            try {
                member = (await api.console.members.put(member))?.member;
            } finally {
                this.loading = false;
                this.search();
            }
        },

        async resend(order) {
            let go = confirm(`${order?.message?.count}회 발송한 주문입니다.\n재발송 하시겠습니까?`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                order = (
                    await api.console.nshop.orders.resend.post({
                        _id: order._id,
                    })
                )?.order;
                this.updateItem(order);
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.orders.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.orders.splice(index, 1, item);
            else {
                this.orders = [item, ...this.orders];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-3 {
        line-height: 1.3;
    }
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
